import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILink from 'UIComponents/link/UILink';
import * as AdsAudienceMembershipActionMetadataKeys from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionMetadataKeys';
import { GET_WORKFLOW_AUDIENCES } from 'automation-ui-action-features/actions/ads-audience-membership/adsAudienceResourceQueries';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { adAudiencesUrl } from 'automation-ui-references/routing/hubspotUrls';
import { useQuery } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
const AdsAudienceMembershipActionDetail = ({
  actionMetadata
}) => {
  const {
    data,
    loading
  } = useQuery(GET_WORKFLOW_AUDIENCES);
  const workflowAudience = data === null || data === void 0 ? void 0 : data.workflowAudiences.find(audience => audience.targetingAudience.id === actionMetadata.get(AdsAudienceMembershipActionMetadataKeys.AUDIENCE_ID));
  if (!loading && !workflowAudience) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.ads-audience-membership.action-detail.cantFetch"
    });
  }

  /**
   * NOTE(bheng): workflowAudience shouldn't be undefined if isLoading=false,
   *   but TS says it might be 🤷
   */
  const audienceLink = loading || !workflowAudience ? /*#__PURE__*/_jsx(SkeletonText, {}) : /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: adAudiencesUrl(workflowAudience.targetingAudience.id),
    onClick: event => event.stopPropagation(),
    children: workflowAudience.networkState.name
  });
  return actionMetadata.get(AdsAudienceMembershipActionMetadataKeys.SHOULD_ADD) ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.ads-audience-membership.action-detail.shouldAdd",
    options: {
      audienceLink
    }
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.ads-audience-membership.action-detail.shouldRemove",
    options: {
      audienceLink
    }
  });
};
export default AdsAudienceMembershipActionDetail;